import { InputModel } from '../input/input.model';
import { RequiredModel } from '../input/rules/implementations/required.model';

export default class RecoveryPasswordModel {
    token: string;
    cpfOuEmail: string;
    novaSenha: string;
    confirmacaoNovaSenha: string;

    novaSenhaInputModel = new InputModel(true, false, 'password', 'Senha', [new RequiredModel()]);
    confirmacaoNovaSenhaInputModel = new InputModel(true, false, 'password', 'Confirmar senha', [new RequiredModel()]);
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/recovery-password/recovery-password.model.ts